/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { Formik, Form } from 'formik';
import { useParams } from 'react-router-dom';
import { Prompt } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import {
  DefaultButton,
  Pivot,
  PivotItem,
  Stack,
  Separator,
  Spinner,
  Text,
} from "@fluentui/react";
import {
    validationSchema, mapInitialValues, route, basicInfoFields, basePath,
    successMsg, setErrorMsg, rootCss, unsavedMsg, platformOptions,
} from '../Helpers/CopyAndFunctions';
import useDataState from '../../../../Util/useDataState';
import useHandleSave from '../../../../Util/useHandleSave';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';
import PrimaryButton from '../../../../Forms/PrimaryButton';
import BasicInfoStep from '../../../../Forms/Steps/BasicInfoStep';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
import FeatureSummary from '../../../../Util/FeatureSummary';

const WizardPage = () => {
    const { tinyUrlId: idFromParams } = useParams();
    const {
        data: tinyUrlData,
        isReady,
        submitForm,
        showSuccess,
        showError,
        setShowError,
        setShowSuccess,
    } = useDataState(idFromParams, route, basePath);
    let history = useHistory();

    if (!isReady) {
        return <Spinner className="absolute-center" text="Loading Redirects Settings..." />;
    }

    return (
        <Formik
            validateOnMount={true}
            initialValues={mapInitialValues(tinyUrlData)}
            onSubmit={async (values, { resetForm }) => {
                if (!values.tinyUrlId) values.tinyUrlId = 0;
                if (!values.createdOn && values.tinyUrlId === 0) values.createdOn = new Date().toISOString();

                await submitForm({ data: values }, resetForm, 'tinyUrlId');
            }}
            isInitialValid={false}
            validationSchema={validationSchema}
        >
            {({ errors, values, isValid, handleSubmit, dirty, isSubmitting }) => {
                const handleSave = useHandleSave(setShowError);

                return values ? (
                    <Form css={[rootCss, {width:500}]}>
                        <Prompt when={dirty} message={unsavedMsg} />
                        <div className="mt-1 form-container">
                            <ChoiceGroup label="Platform" options={platformOptions} name="platformId" />
                            <BasicInfoStep fields={basicInfoFields} />

                            <Separator />
                            <Stack
                                horizontal
                                styles={{
                                    root: {
                                        height: 50,
                                    },
                                }}
                                horizontalAlign={"space-between"}
                                verticalAlign="center"
                            >
                                <DefaultButton onClick={() => { history.push("/content-feature/tinyurls") }} >
                                    {"Back to List"}
                                </DefaultButton>

                                <PrimaryButton
                                    onClick={() => handleSave(isValid, handleSubmit)}
                                    text="Save"
                                    disabled={!dirty || isSubmitting}
                                />
                            </Stack>

                        </div>
                        <SuccessComponent
                            successMessage={successMsg}
                            showSuccess={showSuccess}
                            setShowSuccess={setShowSuccess}
                        />
                        <ErrorComponent
                            errorMessage={setErrorMsg(showError, errors)}
                            showError={showError}
                            setShowError={setShowError}
                        />
                        <FeatureSummary
                            label="About Tiny URLs"
                            summary="Create short, memorable URLs that redirect to longer destination URLs. Select the platform (iGrad or Enrich) and configure the short code and target URL. Tiny URLs are useful for marketing campaigns, printed materials, and social media sharing."
                        />
                    </Form>
                ) : null;
            }}
        </Formik>
    );
};

export default WizardPage;
